/**
 * 금액 계산은 전부 bigint(원 단위)로 한다.
 * number 로 바꾸면 수억 단위에서 정밀도가 깨지고 비율 계산이 어긋난다.
 */

export function toWon(value: string): bigint {
  if (!/^-?\d+$/.test(value)) {
    throw new TypeError(`금액 문자열이 아니다: ${value}`);
  }
  return BigInt(value);
}

export function fromWon(value: bigint): string {
  return value.toString();
}

/** basisPoints: 1% = 100bp. 정수 연산만 사용한다. */
export function applyBasisPoints(amount: bigint, basisPoints: number): bigint {
  if (!Number.isInteger(basisPoints)) {
    throw new TypeError("basisPoints 는 정수여야 한다");
  }
  return (amount * BigInt(basisPoints)) / 10000n;
}

/** 최저가 / 감정가 비율을 basis point 로. 감정가 0 이면 null. */
export function minBidRatioBp(
  minimumBid: bigint,
  appraisal: bigint,
): number | null {
  if (appraisal === 0n) return null;
  return Number((minimumBid * 10000n) / appraisal);
}

export function formatWonKo(amount: bigint): string {
  const neg = amount < 0n;
  let n = neg ? -amount : amount;
  const eok = n / 100000000n;
  n %= 100000000n;
  const man = n / 10000n;
  const won = n % 10000n;
  const parts: string[] = [];
  if (eok > 0n) parts.push(`${eok}억`);
  if (man > 0n) parts.push(`${man}만`);
  if (won > 0n || parts.length === 0) parts.push(`${won}`);
  return `${neg ? "-" : ""}${parts.join(" ")}원`;
}
